const checkPrefix = (phone: string, prefixes: string[]): { prefix: string; phone: string } => {
  const prefix = prefixes.find(p => phone.startsWith(p))
  if (prefix) {
    return {
      prefix,
      phone: phone.slice(prefix.length),
    }
  }
  return {
    prefix: '',
    phone,
  }
}

export default checkPrefix
